import { Column, Entity, PrimaryColumn } from "typeorm";
import { ConnectorStatus } from "../../_objects/connector";

@Entity()
export class ConnectorSchema {
  @PrimaryColumn()
  connectorId: string;

  @Column({ nullable: true })
  connectorName: string | null;

  @Column({ nullable: true })
  tenantId?: string | null;

  @Column({ nullable: true })
  isEnabled: boolean | null;

  constructor(connectorStatus?: ConnectorStatus) {
    Object.assign(this, connectorStatus);
  }
}
